export default __webpack_public_path__ + "static/media/openlibrary.3b884515.png";